import script from "./SnippetRevenue.vue?vue&type=script&setup=true&lang=js"
export * from "./SnippetRevenue.vue?vue&type=script&setup=true&lang=js"

import "./SnippetRevenue.vue?vue&type=style&index=0&id=3e5046b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e5046b2"]])

export default __exports__